/*
 *  Bootstrap Nice Select Italian (Italy) Translation
 *  Author: Kevin Gostomski <kevingostomski2001@gmail.com> 
*/

const localisation = {
    locales: []
}

localisation.locales['it-IT'] = localisation.locales['it'] = {
    formatSearch() {
        return "Ricerca...";
    },
    formatHelpForTagging() {
        return "Per creare i propri tag, focalizzare il campo di input e quindi premere 'Invio' o ',' o 'Barra spaziatrice' per aggiungerlo all'elenco";
    }
}

export default localisation;